import { isNullOrUndefined } from "../../helper/utils";
import Vue from "vue";

Vue.filter("itemURL", function(item, withVariationId = true)
{
    // Prüfe auf Property ID 107 für Custom-URL mit Callisto-Suffix
    let customUrlPath = null;

    if (item.hasOwnProperty("variationProperties"))
    {
        for (let i0 = 0; i0 < item.variationProperties.length; i0++)
        {
            if (item.variationProperties[i0].hasOwnProperty("properties"))
            {
                for (let i = 0; i < item.variationProperties[i0].properties.length; i++)
                {
                    if (item.variationProperties[i0].properties[i].id === 107)
                    {
                        customUrlPath = item.variationProperties[i0].properties[i].values.value;
                    }
                }
            }
            else if (item.variationProperties[i0].property && item.variationProperties[i0].property.id === 107)
            {
                customUrlPath = item.variationProperties[i0].values.value;
            }
        }
    }

    // Wenn Property 107 gefunden: Custom-URL + Callisto-Suffix
    if (customUrlPath !== null)
    {
        const customLink = customUrlPath.charAt(0) === "/" ? customUrlPath : "/" + customUrlPath;

        return customLink + "/a-" + item.item.id+ "/";
    }

    // Normale URL-Logik
    const enableOldUrlPattern = App.config.global.enableOldUrlPattern;
    const urlPath = item.texts.urlPath || "";
    const includeLanguage = !isNullOrUndefined(item.texts.lang) && App.defaultLanguage != item.texts.lang;

    let link = "";

    if (urlPath.charAt(0) !== "/")
    {
        link = "/";
    }

    if (includeLanguage)
    {
        link += item.texts.lang + "/";
    }

    if (urlPath && urlPath.length)
    {
        link += urlPath;
    }

    let suffix = "";

    if (enableOldUrlPattern)
    {
        suffix = "/a-" + item.item.id;
    }
    else if (withVariationId)
    {
        suffix = "_" + item.item.id + "_" + item.variation.id;
    }
    else
    {
        suffix = "_" + item.item.id;
    }

    let trailingSlash = "";

    if (App.urlTrailingSlash)
    {
        trailingSlash = "/";
        if (link.length > 1 && link.charAt(link.length - 1) === "/")
        {
            link = link.substr(0, link.length - 1);
        }
    }

    if (link.substr(link.length - suffix.length, suffix.length) === suffix)
    {
        return link + trailingSlash;
    }

    return link + suffix + trailingSlash;
});
